var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex flex-col w-full p-4 bg-white customShadow transition delay-75 duration-200 ease-in-out",
    },
    [
      _c("div", { staticClass: "flex justify-between items-center mb-3" }, [
        _c("div", [
          _vm.posting.job_title
            ? _c(
                "h2",
                {
                  staticClass:
                    "font-bold text-3xl text-gray-900 sm:truncate mr-4",
                },
                [_vm._v(" " + _vm._s(_vm.posting.job_title) + " ")]
              )
            : _vm._e(),
          _vm.applicationExists
            ? _c("h3", { staticClass: "flex text-lg items-center gap-2" }, [
                _vm._v(
                  "Applied: " +
                    _vm._s(
                      _vm._f("moment")(_vm.application.created_at, "D MMM,YYYY")
                    ) +
                    " "
                ),
                _vm.type
                  ? _c("span", { staticClass: "flex items-center" }, [
                      _c("span", {
                        staticClass:
                          "w-1 h-1 rounded bg-gray-500 block mt-1 mx-2",
                      }),
                      _vm._v(" " + _vm._s(_vm.type)),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "flex gap-2" },
          [
            _c("ApplyButton", {
              attrs: {
                postingId: _vm.posting.id,
                currentUserId: _vm.currentUserId,
                isCancelled: _vm.isApplicationCancelled,
                applicationId: _vm.applicationId,
                withdrawBtnText: "Withdraw Application",
              },
              model: {
                value: _vm.applicationExists,
                callback: function ($$v) {
                  _vm.applicationExists = $$v
                },
                expression: "applicationExists",
              },
            }),
            _vm.applicationExists ? _vm._t("actions") : _vm._e(),
          ],
          2
        ),
      ]),
      _c(
        "div",
        {
          staticClass:
            "flex items-center justify-between w-full gap-8 mb-4 mt-4",
        },
        [
          _c("div", { staticClass: "w-1/2" }, [
            _c("p", { staticClass: "flex items-center mb-2 gap-15" }, [
              _c("span", { staticClass: "text-gray-500" }, [
                _vm._v("Location:"),
              ]),
              _c("span", { staticClass: "text-gray-800 breakWords" }, [
                _vm._v(_vm._s(_vm.location)),
              ]),
            ]),
            _c("p", { staticClass: "flex items-center mb-2 gap-15" }, [
              _c("span", { staticClass: "text-gray-500" }, [
                _vm._v("Duration:"),
              ]),
              _c("span", { staticClass: "text-primary-600" }, [
                _vm._v(_vm._s(_vm.jobDuration || "n/a")),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "w-1/2" }, [
            _c("p", { staticClass: "flex items-center mb-2 gap-15" }, [
              _c("span", { staticClass: "text-gray-500" }, [
                _vm._v("Created:"),
              ]),
              _c("span", { staticClass: "text-gray-600" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("moment")(_vm.posting.created_at, "D MMM, YYYY")
                  )
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "flex gap-15 w-max-content" },
              [
                _c("span", { staticClass: "text-gray-500" }, [
                  _vm._v("Manager:"),
                ]),
                _vm.manager
                  ? _c("ItemChip", {
                      attrs: {
                        itemId: _vm.manager.id,
                        itemName: _vm.manager.name,
                        avatar: _vm.manager.avatar,
                        routeName: _vm.managerRouteName,
                        isPerson: "",
                        chipClass: "bg-chip_custom_class2",
                      },
                    })
                  : _c("p", { staticClass: "text-sm text-primary-black" }, [
                      _vm._v("n/a"),
                    ]),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "bg-gray-100 p-2 flex items-center justify-center" },
        [
          _c("div", { staticClass: "flex flex-col text-center" }, [
            _c("p", { staticClass: "text-lg" }, [_vm._v(_vm._s(_vm.getBudet))]),
            _c("span", { staticClass: "text-base text-gray-500" }, [
              _vm._v("Budget"),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }